module.exports = __webpack_public_path__ + "img/check-motor.833ebba2.svg";